
import WarehouseIcon from '@mui/icons-material/Warehouse';

// export const warehouseFinancialInvoiceComponentsConfig = {
//     products:  {
//         title: 'invoice_products',
//         icon: <WarehouseIcon/>,
//         isSingleDataGrid: true,
//     },
//     costs:  {
//         title: 'costs',
//         icon: <WarehouseIcon/>,
//         isSingleDataGrid: true,
//     },
//     categories:  {
//         title: 'categories',
//         icon: <WarehouseIcon/>,
//         isSingleDataGrid: true,
//     },
//     priceIncreases:  {
//         title: 'price_adjustments',
//         icon: <WarehouseIcon/>,
//         isSingleDataGrid: true,
//     },
// };


export const warehouseFinancialInvoiceComponentsConfig = (hasPriceIncreasePermission,hasInvoiceCategoryPermission, hasInvoiceCostPermission, hasInvoiceProductCategoryPermission) => {
  return {
    products: {
      title: 'invoice_products',
      icon: <WarehouseIcon />,
      isSingleDataGrid: true,
    },
    ...(hasInvoiceProductCategoryPermission && {
      productCategories: {
        title: 'product_categories',
        icon: <WarehouseIcon />,
        isSingleDataGrid: true,
      },
    }),
    ...(hasInvoiceCostPermission && {
      costs: {
        title: 'costs',
        icon: <WarehouseIcon />,
        isSingleDataGrid: true,
      },
    }),
    ...(hasInvoiceCategoryPermission && {
      categories: {
        title: 'categories',
        icon: <WarehouseIcon />,
        isSingleDataGrid: true,
      },
    }),
    ...(hasPriceIncreasePermission && {
      priceIncreases: {
        title: 'price_adjustments',
        icon: <WarehouseIcon />,
        isSingleDataGrid: true,
      },
    }),
  };
}